import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from '../../lib/utils'

const badgeVariants = cva(
  "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default: "border-transparent bg-home-primary text-home-primary-foreground hover:bg-home-primary/80",
        secondary: "border-transparent bg-home-secondary text-home-secondary-foreground hover:bg-home-secondary/80",
        destructive: "border-transparent bg-home-destructive text-home-destructive-foreground hover:bg-home-destructive/80",
        outline: "text-home-foreground",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  },
);

export interface BadgeProps extends React.HTMLAttributes<HTMLDivElement>, VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return <div className={cn(badgeVariants({ variant }), className)} {...props} />;
}

export { Badge, badgeVariants };
